module.exports = __webpack_public_path__ + "static/media/neo.272f5f32.svg";